'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/pow.js
// module id = 1097
// module chunks = 0